import { isTesting, macroCondition } from '@embroider/macros';
import BaseAjaxService from 'ember-ajax/services/ajax';
import {
  getHostDomain,
  isPlatformLocalDomain,
} from 'frontend-utils/utils/domain-checks';
import Cookies from 'js-cookie';

export function extendOptions(
  options: Record<string, unknown>,
): Record<string, unknown> {
  if (isPlatformLocalDomain()) {
    options['crossDomain'] = true;
    options['xhrFields'] = { withCredentials: true };
  }

  if (!('contentType' in options)) {
    options['contentType'] = 'application/json';
  }

  if (macroCondition(isTesting())) {
    return options;
  }

  const csrftoken = Cookies.get('csrftoken');

  // @ts-expect-error: Incorrect type
  if (isWriteOperation(options['method']) && csrftoken) {
    options['headers'] = {
      ...(options['headers'] ?? {}),
      'X-CSRFToken': csrftoken,
    };
  }

  return options;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function isWriteOperation(method: string) {
  return !/^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
}

export default class AjaxService extends BaseAjaxService {
  host = getHostDomain();
  namespace = 'api/v4';

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  options(url: string, options: Record<string, unknown> = {}) {
    // @ts-expect-error: Incorrect type
    return extendOptions(super.options(url, options));
  }
}
